export default __webpack_public_path__ + "static/media/bluecruise2.9ea51758.jpg";